export {
  default as Percent,
  ChangeIndicatedPercent,
} from './percent';
